import { Component, Input } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'simple-table',
  templateUrl: 'simple-table.component.html',
  styleUrls: ['simple-table.component.css']
})
export class SimpleTableComponent {
    @Input()
    headers: string[];

    @Input()
    rows: string[][];
}


// WEBPACK FOOTER //
// ./src/app/shared/simple-table.component.ts